import React from 'react';
import { Link } from 'react-router-dom';
import s from '../../styles/corporate/Corporate.module.css';
import { COMPANY } from '../renewal/data';
import { APPLY_PATH } from './data';

const BIZ_LINKS = [
  { label: 'AI & 데이터 인텔리전스', id: 'business' },
  { label: 'B2B 비즈니스 솔루션', id: 'business' },
  { label: 'HIKS 플랫폼', id: 'hiks' },
  { label: 'ERP & 디지털 전환', id: 'tech' },
];

const COMPANY_LINKS = [
  { label: '회사소개', id: 'about' },
  { label: '기술혁신', id: 'tech' },
  { label: '인재·문화', id: 'people' },
  { label: '사회적 가치', id: 'impact' },
  { label: '문의하기', id: 'contact' },
];

const CHANNELS = [
  { label: '인스타그램', href: 'https://www.instagram.com/offer__group/' },
  { label: '네이버 블로그', href: 'https://blog.naver.com/bni_binkyung' },
];

const CorpFooter = ({ onNavigate }) => (
  <footer className={s.footer}>
    <div className={s.footerInner}>
      <div className={s.footerGrid}>
        <div className={s.footerBrand}>
          <span className={s.footerBrandName} translate="no">
            OFFER GROUP
          </span>
          <p className={s.footerAbout} translate="no">
            오퍼그룹 BNPL은 고객사가 요청한 사업용 자산·비품·원자재 등의 거래내용을 확인한 후,
            오퍼그룹이 해당 물품을 구매하여 고객사에 납품하거나 이용할 수 있도록 제공하고 고객사는
            계약에 따라 분할납부합니다.
          </p>
        </div>

        <nav className={s.footerCol} aria-label="사업영역">
          <span className={s.footerColTitle}>사업영역</span>
          {BIZ_LINKS.map((link) => (
            <button
              type="button"
              className={s.footerLink}
              key={link.label}
              onClick={() => onNavigate(link.id)}
            >
              {link.label}
            </button>
          ))}
          <Link className={s.footerLink} to={APPLY_PATH} translate="no">
            BNPL 상담 신청
          </Link>
        </nav>

        <nav className={s.footerCol} aria-label="회사">
          <span className={s.footerColTitle}>회사</span>
          {COMPANY_LINKS.map((link) => (
            <button
              type="button"
              className={s.footerLink}
              key={link.label}
              onClick={() => onNavigate(link.id)}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className={s.footerCol}>
          <span className={s.footerColTitle}>고객센터</span>
          <a className={s.footerPhone} href={`tel:${COMPANY.phone}`}>
            {COMPANY.phone}
          </a>
          <span className={s.footerSmall}>평일 09:00 – 18:00</span>
          <span className={s.footerSmall}>주말·공휴일 휴무</span>

          <span className={s.footerColTitle} style={{ marginTop: 20 }}>
            채널
          </span>
          <div className={s.footerChannels}>
            {CHANNELS.map((ch) => (
              <a
                className={s.footerLink}
                key={ch.label}
                href={ch.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {ch.label}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className={s.footerBottom}>
        <div className={s.footerLegal}>
          <span>
            주식회사 오퍼그룹 · 대표자명 : {COMPANY.ceo} · 사업자등록번호 : {COMPANY.bizNo}
          </span>
          <span>
            본사 : {COMPANY.address}, {COMPANY.addressDetail}
          </span>
        </div>
        <div className={s.footerMeta}>
          <span>이용약관</span>
          <Link className={s.footerMetaStrong} to={APPLY_PATH}>
            개인정보처리방침
          </Link>
          <span translate="no">© 2026 OFFER GROUP CO., LTD.</span>
        </div>
      </div>
    </div>
  </footer>
);

export default CorpFooter;
